module.exports = __webpack_public_path__ + "img/gb5788.prt.5d123944.jpg";